import APIMapper from './APIMapper';
import AudiencesController from "../../controllers/AudiencesController";
import * as EntityTypes from '../constants/entityTypes';

class AudienceAPIMapper extends APIMapper {
  async update(change) {
    const { item, onSuccess, onError } = change;
    try {
      const bot = item.dependencies.get(EntityTypes.BOT);
      const response = await AudiencesController.putAudience(item.nextValue, bot);
      onSuccess(response)
    } catch (e) {
      onError(e);
    }
  }
}

export default new AudienceAPIMapper();
